import dateFnsParse from 'date-fns/parse';
import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc';

export class WrongFormattedDateError extends Error {
    constructor(msg: string) {
        super(msg);
        Object.setPrototypeOf(this, WrongFormattedDateError.prototype);
    }
}

export function stringToDate(stringValue: string, iso8601: boolean, datePattern: string, datePatternRegex: string): Date | undefined {
    if (!stringValue) {
        return;
    }

    if (iso8601) {
        return zonedTimeToUtc(new Date(stringValue), 'UTC');
    }

    if (!stringValue.match(datePatternRegex)) {
        throw new WrongFormattedDateError(`Unable to parse: ${stringValue}\nPattern used: ${datePatternRegex}`);
    }

    const dateValue = dateFnsParse(stringValue, datePattern, new Date());

    if (isNaN(dateValue.valueOf())) {
        throw new WrongFormattedDateError(`Unable to parse: ${stringValue}\nPattern used: ${datePattern}`);
    }

    return zonedTimeToUtc(dateValue, 'UTC');
}
